module.exports = __webpack_public_path__ + "img/fi.c491ffa7.svg";